var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":_vm.back}},[_c('i',{staticClass:"fa fa-arrow-left fa-fw"})])}
var staticRenderFns = []

export { render, staticRenderFns }